import { Box } from '@mui/material';
import React from 'react';
import { ColorPaper } from '../ColorPaper';
/**
 * Renders a responsive header layout with a configurable background gradient.
 * Intended for use as the main header section of a page.
 *
 * @param {PageHeaderProps} root0 - The props for the component.
 * @param {Gradient} root0.gradient - The background gradient used in the header.
 * @param {React.ReactNode} root0.children - The content of the header.
 * @returns {JSX.Element} The rendered header component with styled layout.
 */
export const PageHeader = ({ gradient, children }) => {
    return (React.createElement(ColorPaper, { gradient: gradient },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: { xs: 'flex-start', lg: 'center' },
                width: '100%',
                gap: { lg: 3 },
            }, "data-test": 'page-header' }, children)));
};
